<template>
  <b-modal
    id="logModal"
    ref="logModal"
    hide-footer
    :no-enforce-focus="true"
    title="Histórico do documento"
    @hidden="fechar()"
  >
    <div>
      <div v-if="!historicos || historicos.length == 0">
        <!-- <no-results
          :icon-size="'150px'"
          :description="'Ninguém visualizou o documento ainda'"
        /> -->
      </div>
      <div
        v-for="historico in historicos"
        v-else
        :key="historico.id"
        class="history-row mb-3 d-inline-flex"
      >
        <!-- <div class=""> -->
        <font-awesome-icon
          :icon="faHistory"
          class="text-primary mr-50"
          style="font-size:1.3rem !important;margin-top: 3px;"
        />
        <!-- </div> -->
        <div class="text-limit">
          <b>{{ historico.usuarioNome }}</b>
          &nbsp;{{ historico.conteudo }}
          <div
            class="detail mt-50"
            style="font-size: 12.5px;"
          ><b>{{ formatDate(historico.dataHora, { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute:'numeric' }) }}</b></div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss">
button.close {
  font-weight: bold;
}

.text-limit {
      overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHistory,
} from '@fortawesome/free-solid-svg-icons'
import { formatDate } from '@core/utils/filter'
import api from '../../services/api'

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    documentoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formatDate,
      faHistory,
      historicos: null,
    }
  },
  created() {
    this.$nextTick(() => {
      this.show()
    })
  },
  methods: {
    show() {
      api.getHistoricos(this.documentoId)
        .then(payload => {
          this.historicos = payload.data
        })
      this.$refs.logModal.show()
    },
    fechar() {
      this.$emit('hidden')
    },
  },
}
</script>
